module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "id": "background-login",
      "src": "/static/img/fondo.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "post",
      "action": "",
      "id": "login",
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.username),
      expression: "data.username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Ingresar nombre de usuario",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.data.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.username), function(error) {
    return _c('div', {
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n                " + _vm._s(error) + "\n            ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.password),
      expression: "data.password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Ingresar contraseña",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.data.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.password), function(error) {
    return _c('div', {
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n                " + _vm._s(error) + "\n            ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.detail), function(error) {
    return _c('div', {
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n            " + _vm._s(error) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn-login"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btningresar",
      "name": "btningresar"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Ingresar")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container login text-center"
  }, [_c('h1', [_vm._v("Bienvenido")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "text"
    }
  }, [_vm._v("Ingresa tus datos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f491c524"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-login.vue
// module id = 85
// module chunks = 0